import React, { useMemo, } from 'react';
import { connect, } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { ShopCartItem, } from 'store/ducks/shopCart/types';
import { sumStatsInCartShopItems, } from 'store/ducks/shopCart/selectors';
import { formatPrice, } from 'common/functions';
import { orangered, } from 'styles/abstract/variables';
import { repositories, } from 'api';
import { StoreBasicDataApiStructure, } from 'common/types';

type Props = {
    sum: string,
    shipmentPrice: number,
};

const SummaryOrderPricePanel: React.FC<Props> = ({
    sum,
    shipmentPrice,
}) => {
    const price = useMemo(
        () => formatPrice(shipmentPrice),
        [ shipmentPrice, ]
    );

    return (
        <Box mt={3}>
            <Grid container
                   direction="column"
                   alignItems="flex-end">
                <Grid item>
                    koszt przesyłki: {price}
                </Grid>
                <Grid item>
                    <Typography variant="h5">
                        DO ZAPŁATY: <Box color={orangered} component="span">{sum}</Box>
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

type MappingType = {
    shopCart: Array<ShopCartItem>,
    checkout: {
        data: StoreBasicDataApiStructure<repositories.CheckoutType>,
        values: any,
    },
};

const mapStateToProps = (state: MappingType) => {
    const shippingForm = state.checkout.values.shippingForm;
    const [ shipments, ] = state.checkout.data.data.shipments;
    const shipmentPrice = shipments ? shipments.methods[shippingForm].price.current : 0;

    return {
        sum: formatPrice(sumStatsInCartShopItems(state).sumPrice),
        shipmentPrice,
    };
};

export default connect(
    mapStateToProps,
)(SummaryOrderPricePanel);
